import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Devolucion } from '../../models/devolucion';
import { PrintPagoHelper } from '../../models/printPagoHelper';
import { SettingService } from '../../services/setting.service';
import { UtilsService } from '../../services/utils.service';
declare var $: any;

@Component({
  selector: 'app-ver-devolucion-modal',
  templateUrl: './ver-devolucion-modal.component.html',
  styleUrls: ['./ver-devolucion-modal.component.scss']
})
export class VerDevolucionModalComponent implements OnInit {

  @Input() isOpen: boolean = false;
  @Input() devolucion: Devolucion | null = null;

  @Output() close = new EventEmitter<void>();

  /** Print modal properties */
  public printPagoHelper: PrintPagoHelper;
  public isModalPrintDevolucionOpen: boolean = false;

  constructor(
    private utilsService: UtilsService,
    private settingService: SettingService
  ) { }

  ngOnInit(): void {
    this.openModal();
  }

  openModal(): void {
    $('#viewDevolucion').show();
  }

  onClose(): void {
    this.close.emit();
  }

  // Abrir el modal de impresion de devolucion
  public openDevolucionPrint(devolucion: Devolucion): void {
    const iva = this.obtenerIvaSetting();
    this.printPagoHelper = PrintPagoHelper.desdeDevolucion(devolucion, iva);
    this.isModalPrintDevolucionOpen = true;
  }

  /** Método para cerrar el modal de impresión */
  public closePrintDevolucionModal(): void {
    this.isModalPrintDevolucionOpen = false;
  }

  private obtenerIvaSetting(): number {
    let iva = 21; // Valor por defecto

    this.settingService.getSettingValue('iva', this.utilsService.getCurrentTiendaId())
      .subscribe(
        data => {
          iva = +data.value || 21;
        },
        error => {
          iva = 21; // IVA por defecto si no se puede obtener
        }
      );

    return iva;
  }

}
